// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"2f822dd7","455":"a08a12fe","578":"9b6b3569","977":"4dc61a07"}[chunkId] + ".chunk.js";
};